import { useCallback } from 'react';
import { VIEW_KIND_TREE } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import { useIsTreeViewEnabled } from '@jira/polaris__lib-entitlement-utils/src/useIsTreeViewEnabled.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import/file-extension-required
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition';

export const useIsViewKindLocked: () => (viewKind: ViewKind) => boolean = functionWithCondition(
	() => fg('jpd_tree-view'),
	(): ((viewKind: ViewKind) => boolean) => {
		const isTreeViewEnabled = useIsTreeViewEnabled();

		return useCallback(
			(viewKind: ViewKind) => {
				switch (viewKind) {
					case VIEW_KIND_TREE:
						return !isTreeViewEnabled;
					default:
						return false;
				}
			},
			[isTreeViewEnabled],
		);
	},
	() => () => false,
);
